import script from "./InfoDataTextRecurring.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoDataTextRecurring.vue?vue&type=script&setup=true&lang=js"

import "./InfoDataTextRecurring.vue?vue&type=style&index=0&id=eff622ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eff622ac"]])

export default __exports__